import { Input } from "antd";
import React from "react";

export const MyInput = ({ placeholder = "", value, onChange, margin = 0 }) => {
  return (
    <Input
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      style={{
        margin: margin,
      }}
    />
  );
};
